import { makeAutoObservable } from 'mobx';
import { ReportBI } from '../services';
import { ConditionalModalState } from './ConditionalModalState';
import { DataExtensionStateBIReporter } from './DataExtensionStateBIReporter';
import { DataExtensionState } from './DataExtensionState';

export interface ArchiveFieldModalStateParams {
  readonly dataExtension: DataExtensionState;
  readonly reportBi: ReportBI;
}

export class ArchiveFieldModalState {
  readonly biReporter;
  readonly dataExtension;
  readonly modal;

  constructor(params: ArchiveFieldModalStateParams) {
    this.biReporter = new DataExtensionStateBIReporter({
      reportBi: params.reportBi,
    });
    this.modal = new ConditionalModalState<{
      id: string;
      origin: string;
    }>({
      onConfirm: async () => {
        if (!this.modal.value) {
          return;
        }

        this.biReporter.reportArchiveFieldModalCtaClicked('Archive');
        await this.dataExtension.archiveField({
          ...this.modal.value,
          reportBi: this.biReporter.reportBi,
        });
      },
      onClose: () => {
        this.biReporter.reportArchiveFieldModalCtaClicked('Cancel');
      },
    });
    this.dataExtension = params.dataExtension;
    makeAutoObservable(this);
  }
}
